import * as React from 'react'
import { graphql } from 'gatsby'
import { ParallaxProvider } from 'react-scroll-parallax'
import { Helmet } from 'react-helmet'

import Header from '../components/Header'
import Bestseller from '../components/Bestseller'
import Services from '../components/Services'
import Footer from '../components/Footer'
import Conferences from '../components/Conferences'
import Media from '../components/Media'
import Communication from '../components/Communication'
import PackagesDistance from '../components/PackagesDistance'
import BlackFriday from '../components/BlackFriday'
import Employees from '../components/Employees'
import Turnovers from '../components/Turnovers'
import Customers from '../components/Customers'
import Map from '../components/Map'
import Branch from '../components/Branch'

const IndexPage = () => {
	return (
		<ParallaxProvider>
			<Helmet>
				<title>NOTINO 2021</title>
			</Helmet>
			<main className="overflow-hidden">
				<Header />
				<Turnovers />
				<Bestseller />
				<Map />
				<Branch />
				<PackagesDistance />
				<Customers />
				<BlackFriday />
				<Communication />
				<Employees />
				<Media />
				<Conferences />
				<Services />
				<Footer />
			</main>
		</ParallaxProvider>
	)
}

export default IndexPage

export const query = graphql`
	query ($language: String!) {
		locales: allLocale(filter: { language: { eq: $language } }) {
			edges {
				node {
					ns
					data
					language
				}
			}
		}
	}
`
